import { Component } from '@angular/core';
import { PackagesTableComponent } from '../packages-table/packages-table.component';
import { PackagesTableFilterComponent } from '../packages-table-filter/packages-table-filter.component';

@Component({
  selector: 'app-packages-page',
  imports: [
    PackagesTableComponent,
    PackagesTableFilterComponent
  ],
  templateUrl: './packages-page.component.html',
  styleUrl: './packages-page.component.scss'
})
export class PackagesPageComponent {

}
